import script from "./AppSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSidebar.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import AppNavItem from "@/components/AppNavItem.vue";
import PlatformSwitcher from "@/components/PlatformSwitcher.vue";
import SetupBadge from "@/components/setup/SetupBadge.vue";
import SidebarAccountCard from "@/components/SidebarAccountCard.vue";
script.components = Object.assign({}, { AppNavItem, PlatformSwitcher, SetupBadge, SidebarAccountCard }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { AppNavItem, PlatformSwitcher, SetupBadge, SidebarAccountCard }, script.__o.components);}